import { render, staticRenderFns } from "./phase-assignment_order-setup-dialog.vue?vue&type=template&id=84dcce7c&scoped=true&"
import script from "./phase-assignment_order-setup-dialog.vue?vue&type=script&lang=ts&"
export * from "./phase-assignment_order-setup-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./phase-assignment_order-setup-dialog.vue?vue&type=style&index=0&id=84dcce7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dcce7c",
  null
  
)

export default component.exports